function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import ErrorBoundary from "@pixel/core/ErrorBoundary";
import Box from "@pixel/core/Box";
import { useMediaQuery, styled } from "@pixel/core/styles";
import { useTheme } from "@pixel/core";
// const BoxStyled = styled(Box, {
//   shouldForwardProp: (prop) => prop !== 'matchesPrint'
// })<BoxStyledPropsExtra>(({  theme, matchesPrint } => ({

// )));

//   backgroundColor: matchesPrint ? theme.palette.common.white : undefined,
//   display: "flex",
//   flexFlow: "column nowrap",
//   flex: 1,
// }));

const BoxStyled = styled(Box, {
  shouldForwardProp: prop => prop !== 'matchesPrint'
})(_ref => {
  let {
    theme,
    matchesPrint
  } = _ref;
  return {
    backgroundColor: matchesPrint ? theme.palette.common.white : undefined,
    display: "flex",
    flexFlow: "column nowrap",
    flex: 1,
    minWidth: 0
  };
});

/** A base-level React component used on every Pixel page.
 * Provides standard Error boundary to the root of your intended page
 * Provides white background when printing
 * In future may contain other root level appropriate functionality
 * Todo: testing, test Error boundary, test paper root layout vs regular, test overridden classes if needed
 */
const LayoutRoot = _ref2 => {
  let {
    elementType = "main",
    children,
    className,
    flexHeight = false,
    ...restProps
  } = _ref2;
  const theme = useTheme();
  const matchesPrint = useMediaQuery('print');

  // const sxProp = {
  //   backgroundColor: matchesPrint ? theme.palette.common.white : undefined,
  //   display: flexHeight ? "flex" : "block",
  //   flexFlow: "column nowrap",
  //   flex: 1,
  // };

  return /*#__PURE__*/React.createElement(BoxStyled, _extends({
    matchesPrint: matchesPrint,
    component: elementType
  }, restProps), /*#__PURE__*/React.createElement(ErrorBoundary, null, children));
};
export default LayoutRoot;